// extracted by mini-css-extract-plugin
export default {"cautionBox":"E9-z"};